export default __webpack_public_path__ + "static/media/Settings_Camera.14556cd3.png";